export const MASTER_TESTING_SESSION_STORAGE = 'mentology.masterTestingOverride';

export function getMasterTestingKey(): string {
  return (import.meta.env.VITE_MASTER_TESTING_KEY as string | undefined)?.trim() ?? '';
}

export function isMasterTestingKey(input: string): boolean {
  const masterKey = getMasterTestingKey();
  if (!masterKey) return false;
  return input.trim() === masterKey;
}

export function activateMasterTestingSession(): void {
  sessionStorage.setItem(MASTER_TESTING_SESSION_STORAGE, '1');
}

export function clearMasterTestingSession(): void {
  sessionStorage.removeItem(MASTER_TESTING_SESSION_STORAGE);
}

export function isMasterTestingSessionActive(): boolean {
  return sessionStorage.getItem(MASTER_TESTING_SESSION_STORAGE) === '1';
}

export function isMasterSandboxUnlocked(
  user?: { masterTestingOverride?: boolean } | null,
): boolean {
  return isMasterTestingSessionActive() || user?.masterTestingOverride === true;
}
